import { createFileRoute } from '@tanstack/react-router';
import { OverviewPage } from '@/features/debts/overview-page.js';

export const Route = createFileRoute('/_app/overview')({
  component: OverviewPage,
});
